<div class="download-container">
  <div class="content">
    <div class="headline">
     {{ 'pdp.info.downloads.headline' | translate }}
    </div>
    <div class="links">
      <kion-link
        *ngFor="let sheet of dataSheets"
        [linkRef]="{url: actualUrl + sheet.url, target: 'true' }"
        [alternativeText]="sheet.altText"
        [showTextOnMobile]="true"
        icon="download"
      ></kion-link>
    </div>
  </div>
</div>
